// extracted by mini-css-extract-plugin
module.exports = {"popper":"styles--popper---ULB_","tooltip":"styles--tooltip--6dsD_","visuallyHidden":"styles--visuallyHidden--3iJuY"};